module.exports = __webpack_public_path__ + "img/folder.9eefb297.png";